import React, { useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Alert from '@mui/material/Alert'
import TextField from '@mui/material/TextField'
import CloseIcon from '@mui/icons-material/Close'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

/**
 * Conferma eliminazione digitando esattamente `nameToMatch` (dopo trim).
 */
export const ConfirmNameDeleteDialog = ({
  open,
  onClose,
  title = 'Conferma eliminazione',
  nameToMatch = '',
  nameFieldLabel = 'Digita per confermare',
  hint = '',
  onConfirm,
  isProcessing = false
}) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    if (open) setValue('')
  }, [open, nameToMatch])

  const normalizedTarget = (nameToMatch || '').trim()
  const isMatch = (value || '').trim() === normalizedTarget
  const canSubmit = isMatch && normalizedTarget.length > 0 && !isProcessing

  const handleConfirm = async () => {
    if (!canSubmit) return
    await onConfirm?.()
  }

  return (
    <Dialog open={open} onClose={isProcessing ? undefined : onClose} maxWidth='sm' fullWidth aria-labelledby='confirm-name-delete-title'>
      <DialogTitle
        id='confirm-name-delete-title'
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <WarningAmberIcon color='warning' />
          <Typography variant='h6' component='span' fontWeight={600}>
            {title}
          </Typography>
        </Box>
        <IconButton onClick={onClose} size='small' aria-label='Chiudi' disabled={isProcessing}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2 }}>
        <Alert severity='warning' variant='outlined' sx={{ mb: 2 }}>
          Questa azione è irreversibile.
        </Alert>
        {hint
          ? (
            <Typography variant='body2' color='text.secondary' sx={{ mb: 1.5 }}>
              {hint}
            </Typography>
            )
          : null}
        <TextField
          fullWidth
          size='small'
          autoFocus
          label={nameFieldLabel}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && canSubmit) handleConfirm()
          }}
          disabled={isProcessing}
          placeholder={normalizedTarget}
          helperText='La conferma è abilitata solo se il testo corrisponde esattamente.'
        />
      </DialogContent>
      <Divider />
      <DialogActions sx={{ px: 3, py: 1.5 }}>
        <Button
          onClick={onClose}
          variant='outlined'
          size='small'
          disabled={isProcessing}
          sx={{ textTransform: 'none', fontWeight: 500 }}
        >
          Annulla
        </Button>
        <Button
          onClick={handleConfirm}
          variant='contained'
          color='error'
          size='small'
          disabled={!canSubmit}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          {isProcessing ? 'Eliminazione...' : 'Elimina definitivamente'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmNameDeleteDialog
